<template>
    <checkout-popup-layout :open="popup.isOpen">
        <transition name="fade">
            <div class="checkout__steps-nest" v-show="popup.isOpen">
                <checkout-step-one v-show="popup.step === 1"></checkout-step-one>
                <checkout-step-two v-show="popup.step === 2"></checkout-step-two>
                <checkout-step-three v-if="popup.step === 3"></checkout-step-three>
            </div>
        </transition>
    </checkout-popup-layout>
</template>

<script>
import CheckoutPopupLayout from './CheckoutPopupLayout.vue';
import CheckoutStepOne from './CheckoutStepOne.vue';
import CheckoutStepTwo from './CheckoutStepTwo.vue';
import CheckoutStepThree from './CheckoutStepThree.vue';
import { fixedTopBarMixin } from '../../mixins/fixedTopBarMixin';
import { mapGetters, mapState } from 'vuex';

export default {
    mixins: [fixedTopBarMixin],

    components: {
        CheckoutStepOne,
        CheckoutStepTwo,
        CheckoutStepThree,
        CheckoutPopupLayout,
    },

    props: {
        checkoutOpened: {
            required: true,
            type: Boolean,
        },
    },

    data: function () {
        return {
            tracking: {
                stepOne: false,
                stepTwo: false,
            },
        };
    },

    mounted() {
        this.tracker.firePixelEvent('product_page_loaded');

        // make decision whether to show the popup and hit the tracking
        if (this.checkoutOpened) {
            if (this.contact) {
                // "window.defaultPaymentMethod" is used in Cypress to mock the default payment method
                if (
                    (this.defaultPaymentMethod && this.defaultPaymentMethod !== 'null') ||
                    window.defaultPaymentMethod
                ) {
                    window.addEventListener('load', () => {
                        this.scrollToPaymentBlock();
                    });

                    return;
                }

                this.$store.commit('openCheckout', {
                    step: 2,
                });

                // don't hit checkout started when we have unfinished checkout link (checkout popup opened on load)
                // this.$store.dispatch('postCheckoutStarted');

                setTimeout(() => {
                    this.tracker.firePixelEvent('checkout_buy_button_is_clicked');
                    this.tracker.firePixelEvent('checkout_step_1_complete');
                }, 2000);
            } else {
                this.$store.commit('openCheckout', {
                    step: 1,
                });

                setTimeout(() => {
                    this.tracker.firePixelEvent('checkout_buy_button_is_clicked');
                }, 2000);
            }
        }
        if (!this.isIosView) return;
        this.eventBus.on('IOSVIEW_OPEN_LIFETIME_UPDATES_POPUP', () => {
            this.$store.commit('setLifetimeUpdates', {
                standalone: true,
            });
            this.$store.commit('openCheckout', {
                step: 3,
            });
        });
    },

    computed: {
        ...mapGetters(['product']),
        ...mapState(['contact', 'braintreeEnvironment', 'popup', 'defaultPaymentMethod']),
        isOpen() {
            return this.popup.isOpen;
        },
    },

    watch: {
        isOpen: function () {
            const body_tag = document.getElementsByTagName('html')[0];
            if (this.isOpen) {
                body_tag.classList.add('stop-scrolling');
            } else {
                body_tag.classList.remove('stop-scrolling');
            }
        },
    },
};
</script>

<style lang="sass" scoped>
.fade-enter-active,
.fade-leave-active
    transition: opacity 0.25s ease

.fade-enter-from,
.fade-leave-to
    opacity: 0
</style>
